import { useEffect } from 'react';

import { instanaReportError } from '@bizzabo/instana-api';

import useMeetingsNotifications from '../hooks/useMeetingsNotifications';
import client from 'client';
import { ScheduledMeeting } from '../types';
import { useMeetings } from '../MeetingsTool/MeetingsToolContext';

const markAsRead = async (eventId: number, notificationIds: string[]) => {
    try {
        const response = await client().post<void>(
            `/api/v2/meetings/events/${eventId}/notifications/bulkUpdate`,
            {
                read: true,
                notificationIds,
            }
        );
        return response.data;
    } catch (error) {
        instanaReportError({ error });
    }
};

const useUnreadNotifications = (meetings: ScheduledMeeting[]) => {
    const { eventId, eventUniqueName } = useMeetings();
    const { hasNewNotification, resetNotification } = useMeetingsNotifications({
        eventUniqueName,
    });

    useEffect(() => {
        if (hasNewNotification && meetings) {
            const notificationsIds = meetings.flatMap(
                meeting =>
                    meeting.notifications?.map(notification => notification.notificationId) || []
            );

            if (notificationsIds.length > 0) {
                markAsRead(eventId, notificationsIds);
                resetNotification();
            }
        }
    }, [hasNewNotification, meetings]);
};

export default useUnreadNotifications;
